export const JOURNAL_NOTE_ITEM_TYPES = {
    TEXT: "0",
    VIDEO: "1",
    AUDIO: "2",
    IMAGE: "3",
    VERSE: "4",
  };
  
  export const SEARCH_TABS = { LANGUAGE: "Language", COUNTRY: "Country" };
  